import ReactDOM from "react-dom";
import loadable from "@loadable/component";
import getWindow from "../utils/window";
import ErrorBoundary from "../components/errorBoundary/ErrorBoundary";
import ProductName from "../components/productName/ProductName";
import StockPriceRetry from "../components/stockPriceRetry/StockPriceRetry";
import LiveRegion from "../components/liveRegion/LiveRegion";
import MixAndMatchProductInfo from "../components/mixAndMatchProductInfo/MixAndMatchProductInfo";
import Spacing, { SPACING } from "../components/spacing/Spacing";
import Prop65GroupWarning from "../components/prop65/Prop65GroupWarning";
import MixAndMatchProducts from "../components/mixAndMatchProducts/MixAndMatchProducts";
import RepeatedTextBanner from "../components/repeatedTextBanner/RepeatedTextBanner";
import styles from "./MixAndMatchPage.scss";
import { useRuntimeConstants } from "../context/runtimeConstants/RuntimeConstantsContext";
import showEarlyAccessBanner from "../../common/showEarlyAccessBanner/showEarlyAccessBanner";
import NewInBox from "../components/newInBox/NewInBox";

const App = loadable(
  () => import(/* webpackChunkName: "deferred" */ "../LoadableComponents"),
  {
    ssr: false,
    resolveComponent: ({ App }) => App,
  }
);

const SocialShare = loadable(
  () => import(/* webpackChunkName: "deferred" */ "../LoadableComponents"),
  {
    ssr: false,
    resolveComponent: ({ SocialShare }) => SocialShare,
  }
);

export default function MixAndMatchPage() {
  const { product } = useRuntimeConstants();
  const showEarlyAccess = showEarlyAccessBanner(product, true);
  return (
    <>
      {showEarlyAccess ? <RepeatedTextBanner /> : null}
      <LiveRegion />
      <div className={styles.titleContainer}>
        <ProductName />
        <SocialShare />
      </div>
      <Spacing size={SPACING.SIXTEEN}>
        <MixAndMatchProductInfo />
        <NewInBox />
        <Prop65GroupWarning />
      </Spacing>
      <StockPriceRetry />
      <MixAndMatchProducts />
      {getWindow()
        ? ReactDOM.createPortal(
            <ErrorBoundary>
              <App />
            </ErrorBoundary>,
            getWindow().document.getElementById("pdp-react-app")
          )
        : null}
    </>
  );
}
